import React, {useEffect, useState} from 'react';
import Translate from '../../../../../../../components/Translate';
import Switch from '../../../../../../../components-new/form/Switch';
import ConfirmationModal from '../../../../../../../components-new/modals/ConfirmationModal';
import {getCompanyInfo, updateMessagingEnabled} from '../../../../../../../services/company/api';
import config from '../../../../../../../config';
import PowerIcon from '../../../../../../../assets/icons/PowerIcon';

export default function MessagingSettings({companyId, addNotification, onStateChange}) {
    const [enabled, setEnabled] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [pending, setPending] = useState(null);
    const [confirmationEnabled, setConfirmationEnabled] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        let active = true;
        getCompanyInfo(companyId).then(data => {
            if (!active) return;
            if (!data) throw new Error('Company info not found');
            setEnabled(data.messagingEnabled !== false);
            onStateChange({companyId, enabled: data.messagingEnabled !== false});
            setLoaded(true);
        }).catch(() => {
            if (active) addNotification('messagingSettingsLoadError', config.notificationLevels.error);
        });
        return () => { active = false; };
    }, [companyId]);

    const confirm = async () => {
        if (saving || pending === null) return;
        setSaving(true);
        try {
            await updateMessagingEnabled(companyId, pending);
            setEnabled(pending);
            onStateChange({companyId, enabled: pending});
            setPending(null);
            addNotification('saved', config.notificationLevels.success);
        } catch (error) {
            addNotification('messagingSettingsSaveError', config.notificationLevels.error);
        } finally {
            setSaving(false);
        }
    };

    return (
        <section className={'stg-card bot-messaging' + (loaded && !enabled ? ' bot-messaging--off' : '')}>
            <div className="bot-messaging__content">
                <span className="bot-messaging__icon"><PowerIcon width={26} height={26}/></span>
                <div className="bot-messaging__text">
                    <div className="bot-messaging__heading">
                        <h3 className="stg-card__title"><Translate text="botMessaging"/></h3>
                        {loaded && <span className="bot-messaging__badge" role="status">
                            <Translate text={enabled ? 'botMessagingEnabled' : 'botMessagingDisabled'}/>
                        </span>}
                    </div>
                    <p className="stg-card__note"><Translate text={loaded && !enabled ? 'botMessagingOffHint' : 'botMessagingHint'}/></p>
                </div>
                <Switch checked={enabled} onChange={value => {
                    setConfirmationEnabled(value);
                    setPending(value);
                }} disabled={!loaded || saving}
                        label={<Translate text="botMessaging"/>}/>
            </div>
            <ConfirmationModal isOpen={pending !== null} loading={saving}
                               icon={<PowerIcon width={24} height={24}
                                                stroke={confirmationEnabled ? 'var(--ds-success-primary)' : 'var(--ds-warning-primary)'}/>}
                               secondaryText={<Translate text={confirmationEnabled ? 'enableBotMessagingDetails' : 'disableBotMessagingDetails'}/>}
                               onClose={() => { if (!saving) setPending(null); }} onConfirm={confirm}
                               message={<Translate text={confirmationEnabled ? 'confirmEnableBotMessaging' : 'confirmDisableBotMessaging'}/>}/>
        </section>
    );
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/overview/MessagingSettings.jsx